/**
 * Quantity field on the product page next to the quantity tiers widget (Rapi).
 *
 * On adding to the cart Rapi sets the quantity field to the selected tier, so with the default
 * "1 ks" tier any typed quantity becomes 1 (Rapi respects the field only for a few shops it lists
 * in its own script). This puts back the quantity the customer set in the field when Rapi forced
 * it to 1. A tier the customer picks (3/6/12 ks) is left to Rapi, which then adds to the cart
 * itself. B2B customers don't see the tiers (snippets/b2b-product-price), so the field always wins.
 */
(() => {
  const FORM = 'form.js-product-form-main';
  let customerQuantity = null;

  // Typing and the +/- buttons; Rapi itself changes the value without an event
  ['input', 'change'].forEach((type) => {
    document.addEventListener(
      type,
      (event) => {
        const input = event.target;
        if (!input || typeof input.matches !== 'function') return;
        if (!input.matches(`${FORM} input[name="quantity"]`)) return;
        const quantity = parseInt(input.value, 10);
        customerQuantity = quantity > 0 ? quantity : null;
      },
      true
    );
  });

  // Runs before the theme reads the form (product-form.js listens on the form itself)
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!form || typeof form.matches !== 'function' || !form.matches(FORM)) return;
      const input = form.querySelector('input[name="quantity"]');
      if (input && customerQuantity > 1 && input.value === '1') input.value = String(customerQuantity);
    },
    true
  );
})();
